import React, {useCallback, useEffect, useState} from 'react'
import { v4 as uuidv4 } from 'uuid'
import MinuteFormat from "Utils/minuteFormat";

const Timer = ({ callback, timeEnd, start = false, stop = false }) => {
    const [id, setId] = useState(null)
    const [ status, setStatus ] = useState(false)
    const [ finishing, setFinishing ] = useState(false)

    const setTime = useCallback((id) => {
        if (stop) return;
        if (!window[`${id}_el`].stop && window[`${id}_el`].currentTime !== 0 && start) window[`${id}_el`].currentTime -= 1000;
    }, [ start, stop ])

    const countdown = useCallback(() => {
        if (timeEnd && id && window[id] && !status) {
            const interval = setInterval(() => {
                const span = window.document.getElementById(id)
                if (!span) {
                    clearInterval(interval)
                    return;
                }
                span.innerHTML = `${ MinuteFormat(window[`${id}_el`].currentTime) }`;
                if (window[`${id}_el`].currentTime === 0) {
                    setFinishing(true)
                    clearInterval(interval)
                }
                setTime(id)
            }, 1000)
            setStatus(true)
        }
    }, [ timeEnd, id, status, start, setTime ])

    useEffect(() => {
        if (id === null) {
            setId(uuidv4())
        } else if (!window[`${id}_el`] && timeEnd) {
            window[`${id}_el`] = {
                timeEnd,
                currentTime: timeEnd
            }
        }
    }, [ id, timeEnd ])

    useEffect(() => {
        if (start && !status && id) {
            countdown();
        }
    }, [start, status, id])

    useEffect(() => {
        if (finishing && callback) {
            callback()
        }
    }, [ finishing, callback ])

    useEffect(() => {
        if (window[`${id}_el`]) window[`${id}_el`].stop = stop
    }, [id, stop]);

    if (id === null) return null
    return (<>
        <span  className={'vert-timer-span'} id={id} />
    </>)
}

export default Timer
